import { render, staticRenderFns } from "./slotMachine.vue?vue&type=template&id=0280f4e0&scoped=true&"
import script from "./slotMachine.vue?vue&type=script&lang=js&"
export * from "./slotMachine.vue?vue&type=script&lang=js&"
import style0 from "./slotMachine.vue?vue&type=style&index=0&id=0280f4e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0280f4e0",
  null
  
)

export default component.exports